module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/november-1e3845dcc7df43b92adf9112b8101400.png";